import { render, staticRenderFns } from "./OfferDisclaimer.vue?vue&type=template&id=0d021832&scoped=true"
import script from "./OfferDisclaimer.vue?vue&type=script&lang=ts"
export * from "./OfferDisclaimer.vue?vue&type=script&lang=ts"
import style0 from "./OfferDisclaimer.vue?vue&type=style&index=0&id=0d021832&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d021832",
  null
  
)

export default component.exports